
import { delay, toList, iterate } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { filter as filter_1, orElse, map, bind, ofNullable, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, float64_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { map as map_1, ofArray, tryHead, filter, tryLast, last, isEmpty, choose } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { SidebarTextButton } from "../Components/Button.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";

const programmaticScrollEventName = "anchor-menu-programmatic-scroll";

const programmaticScrollTimeoutMs = 1000;

const programmaticScrollExtensionMs = 200;

const activationOffsetPx = 24;

const scrollEndTolerancePx = 2;

const scrollOptions = new (class {
    get behavior() {
        return "smooth";
    }
    set behavior(_arg) {
    }
    get block() {
        return "start";
    }
    set block(_arg_1) {
    }
    get inline() {
        return "nearest";
    }
    set inline(_arg_2) {
    }
}
)();

export function scrollToSection(targetId) {
    iterate((element) => {
        element.dispatchEvent(new CustomEvent(programmaticScrollEventName, { detail: targetId, bubbles: true }));
        element.scrollIntoView(scrollOptions);
    }, toArray(ofNullable(document.getElementById(targetId))));
}

export function selectAndScroll(setSelectedAnchor, targetId) {
    scrollToSection(targetId);
    setSelectedAnchor(targetId);
}

function findScrollContainer(element) {
    return bind((parent) => {
        const overflowY = window.getComputedStyle(parent).overflowY;
        if ((overflowY === "auto") ? true : (overflowY === "scroll")) {
            return parent;
        }
        else {
            return findScrollContainer(parent);
        }
    }, ofNullable(element.parentElement));
}

class ScrollArea extends Record {
    constructor(Top, IsScrollable, IsScrolledToEnd) {
        super();
        this.Top = Top;
        this.IsScrollable = IsScrollable;
        this.IsScrolledToEnd = IsScrolledToEnd;
    }
}

function ScrollArea_$reflection() {
    return record_type("Widgets.AnchorMenu.ScrollArea", [], ScrollArea, () => [["Top", float64_type], ["IsScrollable", bool_type], ["IsScrolledToEnd", bool_type]]);
}

function scrollAreaOf(container) {
    if (container == null) {
        const root = document.documentElement;
        return new ScrollArea(0, root.scrollHeight > (window.innerHeight + scrollEndTolerancePx), (window.scrollY + window.innerHeight) >= (root.scrollHeight - scrollEndTolerancePx));
    }
    else {
        const container_1 = container;
        return new ScrollArea(container_1.getBoundingClientRect().top, container_1.scrollHeight > (container_1.clientHeight + scrollEndTolerancePx), (container_1.scrollTop + container_1.clientHeight) >= (container_1.scrollHeight - scrollEndTolerancePx));
    }
}

function detectActiveAnchor(container, anchorIds) {
    const sections = choose((anchorId) => map((element) => [anchorId, element], ofNullable(document.getElementById(anchorId))), anchorIds);
    const area = scrollAreaOf(container);
    if (isEmpty(sections)) {
        return undefined;
    }
    else if (!area.IsScrollable) {
        return undefined;
    }
    else if (area.IsScrolledToEnd) {
        return last(sections)[0];
    }
    else {
        return map((tuple_1) => tuple_1[0], orElse(tryLast(filter((tupledArg) => (tupledArg[1].getBoundingClientRect().top <= (area.Top + activationOffsetPx)), sections)), tryHead(sections)));
    }
}

function AreaAnchor(props) {
    let elems, Variant;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], ["data-test-id", concat("area-anchor-", ...props.Id)], ["data-selected", props.Selected ? "true" : "false"], (elems = [createElement(SidebarTextButton, (Variant = (props.Selected ? "blueButton" : "default"), {
        ComponentState: "enabled",
        Label: props.Label,
        OnClick: () => {
            props.OnClick();
            scrollToSection(props.Id);
        },
        TestId: concat("area-anchor-button-", ...props.Id),
        Variant: Variant,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function AreaAnchorMenu(props) {
    let elems;
    const anchorIds = map_1((anchor) => anchor.Id, props.Anchors);
    const menuElement = reactApi.useRef(undefined);
    const onSelectAnchor = reactApi.useRef(props.OnSelectAnchor);
    const selectedAnchor = reactApi.useRef(props.SelectedAnchor);
    const pendingTarget = reactApi.useRef(undefined);
    const pendingDeadline = reactApi.useRef(0);
    onSelectAnchor.current = props.OnSelectAnchor;
    selectedAnchor.current = props.SelectedAnchor;
    useEffectWithDeps(() => {
        const container = bind(findScrollContainer, menuElement.current);
        const scrollTarget = (container == null) ? window : container;
        const applyDetection = () => {
            const option_2 = filter_1((anchorId) => (anchorId !== selectedAnchor.current), detectActiveAnchor(container, anchorIds));
            iterate(onSelectAnchor.current, toArray(option_2));
        };
        const onScroll = (_arg) => {
            let target;
            const now = Date.now();
            const matchValue = pendingTarget.current;
            let matchResult, target_1;
            if (matchValue != null) {
                if ((target = matchValue, now < pendingDeadline.current)) {
                    matchResult = 0;
                    target_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    pendingDeadline.current = max(pendingDeadline.current, now + programmaticScrollExtensionMs);
                    if (equals(detectActiveAnchor(container, anchorIds), target_1)) {
                        pendingTarget.current = undefined;
                    }
                    break;
                }
                case 1: {
                    pendingTarget.current = undefined;
                    applyDetection();
                    break;
                }
            }
        };
        const onProgrammaticScroll = (event) => {
            pendingTarget.current = (event.detail);
            pendingDeadline.current = (Date.now() + programmaticScrollTimeoutMs);
        };
        scrollTarget.addEventListener("scroll", onScroll);
        window.addEventListener("resize", onScroll);
        scrollTarget.addEventListener(programmaticScrollEventName, onProgrammaticScroll);
        applyDetection();
        return createDisposable(() => {
            scrollTarget.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
            scrollTarget.removeEventListener(programmaticScrollEventName, onProgrammaticScroll);
        });
    }, [join(",", anchorIds)]);
    return reactElement("div", createObj(ofArray([["ref", menuElement], ["className", join(" ", ["sticky", "top-5"])], ["data-test-id", "area-anchor-menu"], (elems = toList(delay(() => map_1((anchor_1) => createElement(AreaAnchor, {
        Id: anchor_1.Id,
        Label: anchor_1.Label,
        OnClick: () => {
            props.OnSelectAnchor(anchor_1.Id);
        },
        Selected: props.SelectedAnchor === anchor_1.Id,
    }), props.Anchors))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

